import { render, staticRenderFns } from "./WorkItemsPropertiesModal.vue?vue&type=template&id=4c6f6be6&"
import script from "./WorkItemsPropertiesModal.vue?vue&type=script&lang=js&"
export * from "./WorkItemsPropertiesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports